import { StyleSheet } from 'aphrodite/no-important';

let styles = {
  form: {
    width: 890
  },
  map: {
    height: 700,
    maxHeight: 'calc(100vh - 225px)'
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/forms/addareaform/areaimageform/AreaImageForm.styles.js